<template>
  <v-app :style="[{ 'background-color': webSettings.bodyColor }]">
    <NotFoundView v-if="notFound" />
    <HomeView v-if="!notFound" />
    <!-- <WebsiteRoot v-if="!isHome && !notFound"/> -->
  </v-app>
</template>

<script lang="ts">
import Vue from "vue";
import HomeView from "./components/HomeView.vue";
import NotFoundView from "./components/NotFoundView.vue";
import { client } from "./services/dispatch-client";
import { WebSettingsDto } from "./components/types";

export default Vue.extend({
  components: {
    HomeView,
    NotFoundView,
  },
  computed: {
    isHome() {
      return this.$route.name == "website.home";
    },
  },
  data() {
    return {
      token:
        "eyJhbGciOiJSUzI1NiIsImtpZCI6ImNmZjA0MTVhMzk2NzFlMzc1NjgyZjBmOTMyZjA1ODcyIiwidHlwIjoiSldUIn0.eyJuYmYiOjE3MjU1NTA4MTYsImV4cCI6MTcyNTU1NDQxNiwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo1MDAxIiwiYXVkIjpbImh0dHA6Ly9sb2NhbGhvc3Q6NTAwMS9yZXNvdXJjZXMiLCJwbGFucyJdLCJjbGllbnRfaWQiOiJmb28iLCJzdWIiOiJkNzE4ODUwZS05ZWFjLTQzZjItYjIzOS0yNDI4OTBhZjFmODkiLCJhdXRoX3RpbWUiOjE3MjU1NTA4MTYsImlkcCI6ImxvY2FsIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiU3VwZXJBZG1pbiIsImVtYWlsIjoic3VwZXIuYWRtaW5AcGJhcy5jYSIsImNvbmZpcm1lZCI6IlRydWUiLCJicm9rZXJpZCI6IjgzODdkYTQ3LWVjNWQtNDRmNS1hYTYzLWMyOTlhOWM2MzM5ZiIsImxhbmd1YWdlIjoiZW4iLCJmaXJzdE5hbWUiOiJTdXBlciIsImxhc3ROYW1lIjoiQWRtaW4iLCJwbGFucyI6IltcInRlc3RfcGxhblwiLFwiMDA0XCJdIiwidW5pb25zIjoiW1wiMGZkNmNlZWEtOWUzYy00OWViLWEwMzItN2I5ZjEyNGYzMDY3XCJdIiwiZW1wbG95ZXJzIjoiW10iLCJzdG9yZXMiOiJbXSIsInJvbGUiOlsiQ2xhaW1zIEFkbWluaXN0cmF0b3IiLCJEb2N1bWVudHMgTWFuYWdlbWVudCBBZG1pbiIsIk1lbWJlciBQb3J0YWwgQWRtaW4iLCJFbXBsb3llciBQcmVtaXVtcyBWaWV3ZXIiLCJQcm92aWRlciIsIkJyb2tlciBQbGFuIE1hbmFnZXIiLCJCcm9rZXIgUGxhbiBDcmVhdG9yIiwiRW1wbG95ZXIgQmVuZWZpY2lhcmllcyBBZG1pbmlzdHJhdG9yIiwiRW1wbG95ZXIgTWVtYmVycyBWaWV3ZXIiLCJCcm9rZXIgU3VwcG9ydCBBZG1pbiIsIkVtcGxveWVyIEJpbGxpbmcgVmlld2VyIiwiVW5pb24gQWRtaW4iLCJNZW1iZXIgUG9ydGFsIFVzZXJzIEFkbWluIiwiRW1wbG95ZXIgRGlyZWN0IERlcG9zaXQgQWRtaW5pc3RyYXRvciIsIkJyb2tlciBVbmlvbiBBZG1pbiIsIkVtcGxveWVyIFVuaW9uIEFkbWluIiwiQnJva2VyIFBsYW4gQWRtaW4iLCJHbG9iYWwgU3VwcG9ydCBNYW5hZ2VyIl0sImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvcm9sZSI6WyJDbGFpbXMgQWRtaW5pc3RyYXRvciIsIkRvY3VtZW50cyBNYW5hZ2VtZW50IEFkbWluIiwiTWVtYmVyIFBvcnRhbCBBZG1pbiIsIkVtcGxveWVyIFByZW1pdW1zIFZpZXdlciIsIlByb3ZpZGVyIiwiQnJva2VyIFBsYW4gTWFuYWdlciIsIkJyb2tlciBQbGFuIENyZWF0b3IiLCJFbXBsb3llciBCZW5lZmljaWFyaWVzIEFkbWluaXN0cmF0b3IiLCJFbXBsb3llciBNZW1iZXJzIFZpZXdlciIsIkJyb2tlciBTdXBwb3J0IEFkbWluIiwiRW1wbG95ZXIgQmlsbGluZyBWaWV3ZXIiLCJVbmlvbiBBZG1pbiIsIk1lbWJlciBQb3J0YWwgVXNlcnMgQWRtaW4iLCJFbXBsb3llciBEaXJlY3QgRGVwb3NpdCBBZG1pbmlzdHJhdG9yIiwiQnJva2VyIFVuaW9uIEFkbWluIiwiRW1wbG95ZXIgVW5pb24gQWRtaW4iLCJCcm9rZXIgUGxhbiBBZG1pbiIsIkdsb2JhbCBTdXBwb3J0IE1hbmFnZXIiXSwiZWRpdG9yIjpbInNydi11c2VyLW1hbmFnZW1lbnQtZG90bmV0LnVzZXIiLCJzcnYtdXNlci1tYW5hZ2VtZW50LWRvdG5ldC5icm9rZXIiXSwibWFuYWdlciI6WyJzcnYtdXNlci1tYW5hZ2VtZW50LWRvdG5ldC51c2VyIiwic3J2LXVzZXItbWFuYWdlbWVudC1kb3RuZXQuYnJva2VyIl0sInZpZXdlciI6WyJzcnYtdXNlci1tYW5hZ2VtZW50LWRvdG5ldC51c2VyIiwic3J2LXVzZXItbWFuYWdlbWVudC1kb3RuZXQuYnJva2VyIl0sInNjb3BlIjpbIm9wZW5pZCIsInByb2ZpbGUiLCJwbGFucyJdLCJhbXIiOlsicHdkIl19.KrnNv5plEM8QU56mtIBd7ytfkCBCe8eF_Kvyrr2ZLDXnTYwiTdh5fm-CV5p6c8ztAJ-tIuzeg6ykS1IzEN5iYMH4xuqX-1iLhYq0Rq3bxhTA8-MFvhR10PnKlAN2u6kOPn1PJPCkqz-A6GU9o6Ff_QVoXjA5zYuYBLpvovvXNYI3xQMVSsHHXkgwNgh2-yLYrJaClPML1HcBNUTgPWbTOX5i15uEp8vxacl6z0lGqt02InE075ZHtcAnmQsuK0Vu5zyXnybKhJTk_rn4IvTiRX_CWsXkUqv60yZBPGvsIdK6-IfB5BtVEeSYm9rnCz5d8-jcnUqHQKd1KXXFUHHgLA",
      notFound: false,
      webSettings: {} as WebSettingsDto,
    };
  },
  mounted() {
    this.getWebSettings();
  },
  methods: {
    async getWebSettings() {
      try {
        this.webSettings = (
          await client.get<WebSettingsDto>("WebSettings")
        ).response;
        if (this.webSettings.id) {
          this.notFound = false;
        } else {
          this.notFound = true;
        }
      } finally {
        console.log(this.notFound);
      }
    },
  },
});
</script>

<style>
.tiptap-content p {
  line-height: 1.5rem;
}

.tiptap-content h1 {
  line-height: 1.5em;
  margin-bottom: 1rem;
}

.tiptap-content h2 {
  line-height: 1.5em;
  margin-bottom: 1rem;
}

.tiptap-content h3 {
  line-height: 1.5em;
  margin-bottom: 1rem;
}
.predetermined {
  background-color: lightblue;
}

.v-tooltip__content {
  max-width: 400px !important;
  width: 400px !important;
}

html {
  overflow: scroll;
  overflow-x: hidden;
}

::-webkit-scrollbar {
  /* Remove scrollbar space */
  background: #f1f1f1;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(30, 136, 229);
}
.top-30 {
  padding-top: 30px;
}
.support-exists {
  padding-top: 30px;
  margin-top: 64px !important;
}
.v-btn {
  letter-spacing: 0 !important;
}
.v-btn:not(.v-btn--round).v-size--default {
  padding: 0 7px !important;
}

.v-dialog--scrollable {
  overflow: visible !important;
}
.v-messages {
  min-height: auto !important;
}
table thead th[role="columnheader"] {
  color: rgb(30, 136, 229) !important;
}

/*
  Added so that the horizontal bar that follows the browser's scroll
  gets properly hidden when the stepper step collapses
*/
.v-stepper__wrapper[style^="height: 0"] {
  display: none;
}

.required label:before {
  content: "* ";
  color: red;
  font-weight: 900;
}

.v-btn__content .v-icon {
  font-size: 20px !important;
  margin-right: 5px !important;
  margin-left: 0px !important;
}

.v-dialog--scrollable > .v-card > div > .v-card__text {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  overflow-y: auto;
}
.required-label:before {
  content: "* ";
  color: red;
  font-weight: 900;
}
</style>
